import React, { useEffect, useState } from 'react'
import './Authentication.scss'
import { useNavigate } from 'react-router-dom'
import { clearCompleteProfileDraft } from '../helper/completeProfileDraft'

export default function SaveConfirm() {
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState("");

  useEffect(() => {
    setCurrentLanguage(localStorage.getItem("language"));
  }, []);

  const handleSave = () => {
    clearCompleteProfileDraft();
    navigate('/');
  }

  return (
    <div className='save_confirm'>
      <div className="icon">
        <img src={`${process.env.PUBLIC_URL}/images/survey/thankyou.svg`} alt="" />
      </div>
      <div className="save_title">
        {currentLanguage === "Italian" ? "Sei sicuro?" : "Are you sure?"}
      </div>
      <div className="save_text">
        {currentLanguage === "Italian" ? "Non potrai cambiarlo per 3 mesi." : "You will not be able to change it for 3 months."}
      </div>
      <div className="action mb15">
        <button onClick={handleSave}>
          {currentLanguage === "Italian" ? "Salva" : "Save"}
        </button>
        <button className='cancel' onClick={() => navigate('/complete-profile')}>
          {currentLanguage === "Italian" ? "Annulla" : "Cancel"}
        </button>
      </div>
    </div>
  )
}
